"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";

import { useShowsModel } from "./showsPageModel";
import ShowsHeader from "./_cmp/ShowsHeader";
import ShowsToolbar from "./_cmp/ShowsToolbar";
import ShowList from "./_cmp/ShowList";
import ShowListSkeleton from "./_cmp/ShowListSkeleton";
import ShowMonthNav from "./_cmp/ShowMonthNav";
import ShowCalendarGrid from "./_cmp/ShowCalendarGrid";
import ShowCalendarSkeleton from "./_cmp/ShowCalendarSkeleton";
import { Calendar } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function Shows() {
  const {
    shows,
    filteredShows,
    isLoading,
    isSearchActive,
    viewMode,
    setViewMode,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    kpis,
    calendarYear,
    calendarMonth,
    setCalendarMonth,
    goToDate,
  } = useShowsModel();

  const isMobile = useIsMobile();
  const effectiveViewMode = isSearchActive || isMobile ? "list" : viewMode;

  const list = isLoading ? (
    <ShowListSkeleton showMonthNav={!isSearchActive} />
  ) : (
    <ShowList
      shows={filteredShows}
      year={isSearchActive ? undefined : calendarYear}
      month={isSearchActive ? undefined : calendarMonth}
      onMonthChange={isSearchActive ? undefined : setCalendarMonth}
    />
  );

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 bg-card/80 px-3 pb-0 pt-2 backdrop-blur-sm">
            <PageHeader
              title="Shows"
              icon={Calendar}
              subtitle={`${shows.length} shows · ${kpis.onSaleCount} on sale`}
              actions={<ShowsHeader />}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            <ShowsToolbar
              search={search}
              onSearchChange={setSearch}
              statusFilter={statusFilter}
              onStatusFilterChange={setStatusFilter}
              viewMode={viewMode}
              onViewModeChange={setViewMode}
            />
            {!isSearchActive && (
              <div className="-mx-3 border-t border-border">
                <ShowMonthNav year={calendarYear} month={calendarMonth} onMonthChange={setCalendarMonth} />
              </div>
            )}
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Shows"
          icon={Calendar}
          subtitle={`${shows.length} shows · ${kpis.onSaleCount} on sale`}
          actions={<ShowsHeader />}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 p-5">
          <ShowsToolbar
            search={search}
            onSearchChange={setSearch}
            statusFilter={statusFilter}
            onStatusFilterChange={setStatusFilter}
            viewMode={viewMode}
            onViewModeChange={setViewMode}
          />

          {effectiveViewMode === "list" ? (
            list
          ) : isLoading ? (
            <ShowCalendarSkeleton />
          ) : (
            <ShowCalendarGrid
              shows={filteredShows}
              year={calendarYear}
              month={calendarMonth}
              onMonthChange={setCalendarMonth}
              onDateClick={goToDate}
            />
          )}
        </div>
      </div>
    </PageContainer>
  );
}
